import { isMobileBrowser } from '@rover/utilities/device';

import $ from '@rover/globals/jquery';
import _ from '@rover/globals/underscore';
import Backbone from '@rover/globals/backbone';
import Rover from '@rover/globals/Rover';

export default Backbone.View.extend({
  footerFixedClasses: 'rover-modal-mobile-footer fixed',
  headerFixedClasses: 'rover-modal-mobile-header fixed',

  initialize(options) {
    this.$modal = this.$('.js-rover-modal');
  },

  onContentLoaded() {
    this.$body = this.$('.js-modal-body');
    this.$footer = this.$('.js-modal-footer');
    this.$header = this.$('.js-modal-header');

    this.showFooter();
    this.showHeader();

    // Show/hide the footer on modal show/hide
    this.$modal.on('show.bs.modal', _.bind(this.showFooter, this));
    this.$modal.on('show.bs.modal', _.bind(this.showHeader, this));
    this.$modal.on('hide.bs.modal', _.bind(this.hideFooter, this));
    this.$modal.on('hide.bs.modal', _.bind(this.hideHeader, this));
    this.$modal.on('hidden.bs.modal', _.bind(this.removeBackdrop, this));
  },

  showModal() {
    this.$modal.modal('show').focus();
  },

  hideModal() {
    this.$modal.modal('hide');
  },

  destroyView() {
    this.undelegateEvents();
    this.remove();
  },

  showFooter() {
    if (!isMobileBrowser()) {
      return;
    }
    this.showMobileFooter();
  },

  showMobileFooter() {
    this.$footer.addClass(this.footerFixedClasses);
    this.$footer.detach().insertAfter(this.$modal);
    this.originalBodyPaddingBottom = this.$body.css('padding-bottom');
    this.$('.js-modal-body').css('padding-bottom', this.$footer.outerHeight());
  },

  hideFooter() {
    if (!isMobileBrowser()) {
      return;
    }
    this.hideMobileFooter();
  },

  hideMobileFooter() {
    this.$footer.removeClass(this.footerFixedClasses);
    this.$footer.detach().insertAfter(this.$body);
    this.$body.css('padding-bottom', this.originalBodyPaddingBottom);
  },

  showHeader() {
    if (!isMobileBrowser()) {
      return;
    }
    this.showMobileHeader();
  },

  showMobileHeader() {
    // We're making the body fixed to prevent the "background"
    // from scrolling on iOS.
    $('.js-search-page').addClass('fixed');

    this.$header.removeClass('hidden');
    this.$header.addClass(this.headerFixedClasses);
    this.$header.detach().insertBefore(this.$modal);
    this.originalBodyPaddingTop = this.$body.css('padding-top');
    this.$body.css('padding-top', this.$header.outerHeight() + 8);
  },

  hideHeader() {
    if (!isMobileBrowser()) {
      return;
    }
    this.hideMobileHeader();
  },

  hideMobileHeader() {
    $('.js-search-page').removeClass('fixed');
    this.$header.addClass('hidden');
    this.$header.removeClass(this.headerFixedClasses);
    this.$header.detach().insertBefore(this.$body);
    this.$body.css('padding-top', this.originalBodyPaddingBottom);
  },

  removeBackdrop() {
    // TODO: Figure out what is causing two modal-backdrops
    // to appear
    $('.modal-backdrop').remove();
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/mobile_supported_modal_view.js